import { render, staticRenderFns } from "./OrganizationRevs.vue?vue&type=template&id=45e498d8"
import script from "./OrganizationRevs.vue?vue&type=script&lang=js"
export * from "./OrganizationRevs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports